<template>
  <!-- 订单详情页面 -->
  <div class>
    <div class="clearFix top-btn-box">
      <router-link class="floatl" to="/pc/order-list">＜＜ 返回订单列表</router-link>
    </div>
    <div class="div-top-tip">订单信息</div>
    <div class="register-input-box">
      <div class="color666">
        <span>订单编号：</span>
        <span>{{dataForm.viewId}}</span>
      </div>
      <div>
        <span>状态：</span>
        <span>{{dataForm.status}}</span>
      </div>
      <div>
        <span>下单时间：</span>
        <span>{{ formatDate(dataForm.payTime) }}</span>
      </div>
      <div>
        <span>收货人：</span>
        <span>{{dataForm.contactUser}}</span>
      </div>
      <div>
        <span>收货电话：</span>
        <span>{{dataForm.phoneNumber}}</span>
      </div>
      <div>
        <span>收货地址：</span>
        <span>{{dataForm.unitProvinceCity}}{{dataForm.unitLocation}}</span>
      </div>
      <div>
        <span>合同编号：</span>
        <span>{{dataForm.contractNo}}</span>
      </div>
      <div>
        <span>备注：</span>
        <span>{{dataForm.note}}</span>
      </div>
    </div>

    <div class="div-top-tip">订单流转</div>
    <el-table
      class="roam-table"
      ref="multipleTable"
      :data="roam"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column prop="updateTime" label="时间">
        <template slot-scope="scope">
          <span>{{ formatDate(scope.row.circulationTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="circulationStatus" label="处理信息" :formatter="check"></el-table-column>
      <el-table-column prop="circulationStatus" label="操作人" :formatter="operating"></el-table-column>
    </el-table>

    <div class="div-top-tip">订单产品</div>
    <el-table
      class="goods-table"
      max-height="400"
      ref="multipleTable"
      :data="goodsTable"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column prop="productName" label="产品名称" show-overflow-tooltip width="200"></el-table-column>
      <el-table-column prop="orderNo" label="产品编号" show-overflow-tooltip width="200"></el-table-column>
      <el-table-column prop="specifications" label="规格"></el-table-column>
      <el-table-column prop="brandName" label="品牌" width="100" align="center"></el-table-column>
      <el-table-column prop="packaging" label="主计量单位" width="100" align="center"></el-table-column>
      <el-table-column prop="pyMoney" label="标准价(￥)" width="100" align="center"></el-table-column>
      <el-table-column prop="goodsPrice" label="会员价(￥)" width="100" align="center"></el-table-column>
      <el-table-column prop="goodsNumber" label="数量"></el-table-column>
      <el-table-column prop="goodsMoney" label="总金额(￥)" width="100" align="center"></el-table-column>
    </el-table>
    <el-row class="sum-money-box">
      <el-col class="sum-money" :span="24" v-if="sumMoney==0">
        合计：
        <span class="sum-red"></span> 0 元
      </el-col>
      <el-col class="sum-money" :span="24" v-else>
        合计：
        <span class="sum-red">{{sumMoney}}</span> 元
      </el-col>
    </el-row>

    <div class="div-top-tip">合同模版</div>
    <div class="agreement-box">
      <img src="./style/img/contract.jpg" class="agreement-img" alt="合同">
      <el-button @click="downs" type="primary" class="agreement-btn">点击下载</el-button>
    </div>
  </div>
</template>

<script>
import { post, get } from "@/axios/index";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from "element-china-area-data";
export default {
  data() {
    return {
      //合同路径
      agreementUrl: "http://pbqs4mb1e.bkt.clouddn.com/WechatIMG279.jpeg",
      //省市数据
      provinceOptions: provinceAndCityData,
      //表单数据
      dataForm: {
        orderViewId: "12344",
        status: "已出库",
        orderTime: 1540968664,
        //详细地址
        addressDetail: "是是是是是是所所",
        //省市选中值
        //收货人姓名
        contact: "张大明",
        //收货人电话
        contactMobilePhone: ""
      },
      //订单流转
      roam: [
        {
          time: 1540968664,
          circulationStatus: 1
        }
      ],
      //购物车商品数据
      goodsTable: [
        {
          name: "glycine甘氨酸",
          number: "15835672532756",
          format: "500g",
          brand: "MP",
          price: "220",
          VIPPrice: "200",
          totalPrice: "400",
          sum: "2"
        }
      ],
      orderId: "",
      userRegID: 0,
      num: 0,
      //合计金额
      sumMoney: 0
    };
  },
  methods: {
    //下载图片
    downloadImg(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    async downs() {
      console.log(this.orderId);
      window.location.href = `${
        this.$base.uploadFlie
      }/api/exportzip/export_zip?orderId=${this.orderId}`;
    },
    operating(row) {
      // console.log('次数',0)
      switch (row.circulationStatus) {
        case 1:
          return "用户";
          break;
        default:
          return "管理员";
      }
    },
    check(row) {
      switch (row.circulationStatus) {
        case 1:
          return "用户提交,正在审核";
          break;
        default:
          return "审核通过";
      }
    }
  },
  created() {
    this.orderId = this.$route.query.id;
    this.userRegID = JSON.parse(localStorage.getItem("stkMessage")).id;
    get("/stkorderinfo/getbyid", { id: this.orderId }).then(res => {
      console.log("订单信息,res-------", res.data);
      this.dataForm = res.data.result;
    });
    get("/stkorderinfo/getbyorderid", { orderId: this.orderId }).then(res => {
      console.log("产品信息,res---------", res.data);
      this.goodsTable = res.data.result;
      this.goodsTable.forEach(ele => {
        this.sumMoney += ele.goodsMoney;
      });
      this.sumMoney = this.sumMoney.toFixed(2);
    });
    get("/stkorderinfo/getordercirculationlist", {
      orderId: this.orderId,
      userRegisterId: this.userRegID
    }).then(res => {
      console.log("订单流转res---", res.data);
      this.roam = res.data.result;
    });
  }
};
</script>

<style lang="less" scoped>
.top-btn-box {
  .common-content-width();
  margin-bottom: 26px;
  margin-top: 30px;
  .floatl {
    display: block;
    line-height: 48px;
    color: @common-blue;
  }
}

.agreement-box {
  .common-content-width();
  .common-shadow();
  padding-bottom: 26px;
  margin-bottom: 50px;
}

/deep/.register-input-box {
  padding: 31px;
  margin-bottom: 50px;
  .common-shadow();
  .common-content-width();
  margin-bottom: 50px;
  color: #999;
  line-height: 40px;
}

/deep/.goods-table,
.roam-table {
  .common-content-width();
  margin-bottom: 50px;
  .common-shadow();
  tr th:first-child {
    padding-left: 20px !important;
  }
  tr td:first-child {
    padding-left: 20px !important;
    .cell {
      color: #666 !important;
    }
  }
  tr td:nth-last-child(3),
  tr td:nth-last-child(2) {
    .cell {
      color: @color-orange !important;
    }
  }
}

.roam-table {
  tr td:nth-last-child(3),
  tr td:nth-last-child(2) {
    .cell {
      color: inherit !important;
    }
  }
}

.addressDetail {
  .el-input {
    width: 100%;
  }
}

.table-tip-link {
  color: @common-blue;
}

.agreement-img {
  display: block;
  width: 150px;
  height: 200px;
  margin: 23px auto;
}

.agreement-btn {
  margin: 0 auto;
  display: block;
}
.sum-money-box {
  height: 60px;
  line-height: 60px;
  margin: 0 auto 60px;
  background: rgb(230, 230, 230);
  width: 96%;
  .sum-money {
    padding-left: 80%;
    .sum-red {
      color: #ff5f5f !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/order/OrderDetail.vue